import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { formatInTimeZone } from 'date-fns-tz';

function formatTime(date?: string | Date, timeZone?: string, format?: string) {
  if (!date || !format) return 'N/A';
  return formatInTimeZone(new Date(date), timeZone ?? '', format);
}

function formatTooltipDate(date: Date, timeZone?: string, utcOffsetString?: string) {
  const tz = timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const time = formatTime(date, timeZone, 'h:mm aaaa').toUpperCase();
  const dateStr = formatTime(date, timeZone, 'PP');
  const timezoneName = date
    .toLocaleString('en-US', {
      timeZoneName: 'long',
      timeZone: tz,
    })
    .split(',')
    .pop()
    ?.trim();
  return (
    <div className="space-y-2 text-sm">
      <div>
        <div className="font-semibold">Time</div>
        <div>{time}</div>
      </div>
      <div>
        <div className="font-semibold">Date</div>
        <div>{dateStr}</div>
      </div>
      <div>
        <div className="font-semibold">Timezone</div>
        <div>
          {timezoneName} ({utcOffsetString})
        </div>
      </div>
    </div>
  );
}

interface EventTimeDisplayProps {
  label: string;
  date: string | Date | null;
  compactDisplay: boolean;
  utcOffsetString: string;
  timeZone: string | undefined;
}

export function EventTimeDisplay({
  label,
  date,
  compactDisplay,
  utcOffsetString,
  timeZone,
}: EventTimeDisplayProps) {
  return (
    <div className="flex flex-1 flex-row justify-between border-b border-[#2E3835] p-4 items-center">
      <p className="font-semibold text-white">{label}</p>
      <p className="text-gray-400">
        {date ? (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                {!compactDisplay ? (
                  <>
                    {formatTime(date, timeZone, 'h:mm aaaa').toUpperCase()}{' '}
                    {utcOffsetString}
                    <br /> {formatTime(date, timeZone, 'PP')}
                  </>
                ) : (
                  <p className="text-gray-400 text-end">
                    {formatTime(date, timeZone, 'h:mm aaaa').toUpperCase()} -{' '}
                    {formatTime(date, timeZone, 'PP')}
                  </p>
                )}
              </TooltipTrigger>
              <TooltipContent className="bg-[#1b1b1b] text-white">
                {formatTooltipDate(new Date(date), timeZone, utcOffsetString)}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        ) : (
          'Unknown'
        )}
      </p>
    </div>
  );
}
